import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export interface CreateBrandData {
  company: string;
  subDomain: string;
}

export const CreateBrandFormResolver = yupResolver<CreateBrandData>(
  yup
    .object({
      company: yup.string().min(3).required(),
      subDomain: yup.string().min(3).required(),
    })
    .required(),
);

export const subDomains = [
  'mehmetusta',
  'meshurdondurmaci',
  'sahanedoner',
  'ustanin-elinden',
  'hanim_eli',
  'sicakgozleme',
];
